import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdateVehicleRes;
export const UpdateVehicleTodo = createAsyncThunk('UpdateVehicle', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL +'vehicle_master',
            data: data,
            headers: { "Content-Type":"multipart/form-data"  , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateVehicleRes = res.data
        
    } catch (error) {
        return UpdateVehicleRes = error.response.data
    }
})
